import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ApiResponse } from '@app/_models';
import { MessageTemplateService } from '@app/_components/message/message-template';
import { AlertService } from '@app/_services';

@Injectable({
	providedIn: 'root'
})

@Injectable()
export class MessageTemplateResolver  {

	constructor(
		private router: Router,
		private messageTemplateService: MessageTemplateService,
		private alertService: AlertService) { }

	resolve(activatedRouteSnapshot: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): Observable<ApiResponse>
	{
		return this.messageTemplateService.findAll();
	}
}
